import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import onboardingsIcon from '../../assets/MyOnboardingsIcon.svg';
import IncompleteOnboardingSummary from '../../components/IncompleteOnboardingSummary/IncompleteOnboardingSummary';
import NavigationFooter from '../../components/NavigationFooter/NavigationFooter';
import Status from '../../components/Status/Status';
import { FormStatusEnum } from '../../types/enums/form-status.enum';
import { FormStepEnum } from '../../types/enums/form-step.enum';
import { pagesPaths } from '../../utils/navigationUtils';
import { continueOnboardingWizard } from '../../utils/onboardingNavigation';

interface IncompleteOnboardingLocationState {
  commerceRut: number;
  businessData: any;
  state: FormStatusEnum;
  step: FormStepEnum;
}

// Read-only preview shown when opening a "Sin completar" onboarding, reached from MyOnboardings'
// "ver" action. Lets the user delete it or resume the wizard from where it was left off.
function IncompleteOnboarding() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const localState = location.state as IncompleteOnboardingLocationState | null;
  const businessData = localState?.businessData || {};

  const handleGoBack = () => navigate(pagesPaths.MyOnboardings);

  const handleContinue = async () => {
    if (!localState) return;

    setIsLoading(true);
    await continueOnboardingWizard(navigate, { ...localState, from: pagesPaths.MyOnboardings });
    setIsLoading(false);
  };

  return (
    <>
      <Container className="incomplete-onboarding">
        <h1 className="mb-5">
          <img src={onboardingsIcon} alt="Onboardings" className="me-3" />
          Onboardings
        </h1>
        <Status status={businessData.status} />
        <IncompleteOnboardingSummary businessData={businessData} onDeleted={handleGoBack} />
      </Container>
      <NavigationFooter
        previousHandler={handleGoBack}
        previousText="Volver"
        nextHandler={handleContinue}
        nextText="Continuar alta"
        loading={isLoading}
      />
    </>
  );
}

export default IncompleteOnboarding;
